import React, { useState } from 'react';

const CALL_OPTIONS = [
  {
    type: 'call',
    label: '직원 호출',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
  },
  {
    type: 'water',
    label: '물 요청',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/>
      </svg>
    ),
  },
  {
    type: 'tissue',
    label: '냅킨 요청',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <path d="M12 8v8M8 12h8"/>
      </svg>
    ),
  },
  {
    type: 'plate',
    label: '접시 요청',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <circle cx="12" cy="12" r="10"/>
        <circle cx="12" cy="12" r="4"/>
      </svg>
    ),
  },
  {
    type: 'custom',
    label: '기타 요청',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
];

export default function StaffCallSheet({ open, onClose, onSubmit }) {
  const [customMessage, setCustomMessage] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);

  if (!open) return null;

  const handleSelect = (type) => {
    if (type === 'custom') {
      setShowCustomInput(true);
      return;
    }
    onSubmit({ type, message: '' });
    setShowCustomInput(false);
    setCustomMessage('');
  };

  const handleCustomSubmit = () => {
    if (!customMessage.trim()) return;
    onSubmit({ type: 'custom', message: customMessage.trim() });
    setShowCustomInput(false);
    setCustomMessage('');
  };

  const handleClose = () => {
    setShowCustomInput(false);
    setCustomMessage('');
    onClose();
  };

  return (
    <>
      <div className="overlay animate-fade-in" onClick={handleClose} />
      <div className="bottom-sheet">
        <div className="bottom-sheet-handle" />
        <div style={{ padding: '8px 20px 20px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 20,
          }}>
            <h3 style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>
              직원 호출
            </h3>
            <button className="sheet-close-btn" style={{ position: 'static' }} onClick={handleClose}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>

          {!showCustomInput ? (
            <div className="stagger-children" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {CALL_OPTIONS.map((opt, idx) => (
                <button
                  key={opt.type}
                  className="animate-fade-in-up"
                  onClick={() => handleSelect(opt.type)}
                  style={{
                    animationDelay: `${idx * 40}ms`,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    padding: '16px 16px',
                    border: 'none',
                    borderRadius: 'var(--radius-md)',
                    background: 'var(--border)',
                    cursor: 'pointer',
                    fontFamily: 'var(--font)',
                    fontSize: 15,
                    fontWeight: 600,
                    color: 'var(--text)',
                    transition: 'background 0.15s ease',
                    width: '100%',
                    textAlign: 'left',
                  }}
                >
                  <div style={{
                    width: 40,
                    height: 40,
                    borderRadius: 'var(--radius-md)',
                    background: 'var(--primary-light)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--primary)',
                    flexShrink: 0,
                  }}>
                    {opt.icon}
                  </div>
                  {opt.label}
                </button>
              ))}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ fontSize: 14, color: 'var(--text-tertiary)', fontWeight: 500 }}>
                요청 사항을 입력해주세요
              </div>
              <input
                type="text"
                value={customMessage}
                onChange={(e) => setCustomMessage(e.target.value)}
                placeholder="예: 숟가락 추가 부탁드립니다"
                autoFocus
              />
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  className="btn btn-secondary"
                  style={{ flex: 1 }}
                  onClick={() => setShowCustomInput(false)}
                >
                  뒤로
                </button>
                <button
                  className="btn btn-primary"
                  style={{ flex: 1 }}
                  onClick={handleCustomSubmit}
                  disabled={!customMessage.trim()}
                >
                  호출하기
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
